/**
 * Trigger: tr_account_transfers_soft_delete_external
 * Purpose: When an account transfer is soft-deleted, detach its related external marker links
 * Table: account_transfers
 * Event: UPDATE OF is_deleted
 */
export const TR_ACCOUNT_TRANSFERS_SOFT_DELETE_EXTERNAL = `
CREATE TRIGGER tr_account_transfers_soft_delete_external
UPDATE OF is_deleted ON account_transfers
WHEN new.is_deleted <> 0 AND old.is_deleted = 0
BEGIN
  UPDATE external_transactions
  SET account_transfer_id = NULL
  WHERE account_transfer_id = old._id AND is_deleted = 0;
END;
`;
